// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1aGKD","footer":"ModalCreateQualiphyProcedure_footer__2AJJK","additionData":"ModalCreateQualiphyProcedure_additionData__QO4IT"};